export const workflowKeys = {
  all: ['workflows'] as const,
  lists: () => [...workflowKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...workflowKeys.lists(), filters] as const,
  detail: (id: string) => [...workflowKeys.all, 'detail', id] as const,
  catalogue: (tenantId: string) => [...workflowKeys.all, tenantId, 'catalogue'] as const,
  catalogueByTag: (tenantId: string, tag: string) =>
    [...workflowKeys.all, tenantId, 'catalogue', tag] as const,
};
